import { useDeals } from './hooks/useDeals'
import Header from './components/Header'
import HeroBanner from './components/HeroBanner'
import Filters from './components/Filters'
import DealsGrid from './components/DealsGrid'
import LoadMoreButton from './components/LoadMoreButton'
import Footer from './components/Footer'

const App = () => {
  const {
    search, category, sort,
    deals, totalFiltered, hasMore, remaining,
    setSearch, setCategory, setSort, loadMore,
  } = useDeals()

  return (
    <div className="min-h-screen flex flex-col">
      <Header search={search} onSearch={setSearch} />

      <main className="flex-1">
        <HeroBanner />

        <Filters
          category={category}
          onCategory={setCategory}
          sort={sort}
          onSort={setSort}
          totalFiltered={totalFiltered}
        />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
          {/* Results header */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="font-display text-lg font-bold text-slate-800">
              {totalFiltered > 0
                ? `${totalFiltered} deal${totalFiltered !== 1 ? 's' : ''} found`
                : 'No deals found'}
            </h2>

            {search && (
              <p className="text-sm text-slate-500">
                Results for{' '}
                <span className="font-semibold text-brand-600">{search}</span>
              </p>
            )}
          </div>

          <DealsGrid deals={deals} search={search} category={category} />

          {hasMore && (
            <LoadMoreButton onClick={loadMore} remaining={remaining} />
          )}
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default App
